var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      attrs: {
        "close-on-content-click": false,
        "max-width": 320,
        "min-width": 290,
        disabled: _vm.disabled,
        readonly: _vm.readonly
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            var attrs = ref.attrs
            return [
              _c(
                "v-form",
                {
                  ref: "form-date",
                  staticClass: "form-date-input",
                  attrs: { "lazy-validation": "" }
                },
                [
                  !_vm.readonly
                    ? _c(
                        "v-icon",
                        _vm._g(
                          _vm._b(
                            {
                              staticClass: "icon-event",
                              attrs: { color: "primary" }
                            },
                            "v-icon",
                            attrs,
                            false
                          ),
                          on
                        ),
                        [_vm._v("event")]
                      )
                    : _vm._e(),
                  _c("v-text-field", {
                    staticClass: "n-date-picker",
                    class: _vm.readonly && "n-date-picker--readonly",
                    attrs: {
                      value: _vm.formattedValue,
                      label: _vm.label,
                      clearable: _vm.clearable,
                      disabled: _vm.disabled,
                      outlined: true,
                      rules: _vm.inputRules,
                      placeholder: _vm.placeholder_,
                      "persistent-placeholder": ""
                    },
                    on: {
                      "click:clear": function($event) {
                        return _vm.onChangeDate(null)
                      },
                      change: function(v) {
                        return _vm.onInputDate(v)
                      },
                      keydown: function(e) {
                        return _vm.onKeydown(e)
                      }
                    }
                  })
                ],
                1
              )
            ]
          }
        }
      ]),
      model: {
        value: _vm.menu,
        callback: function($$v) {
          _vm.menu = $$v
        },
        expression: "menu"
      }
    },
    [
      _c("v-date-picker", {
        ref: "picker",
        attrs: {
          value: _vm.value_,
          "first-day-of-week": 1,
          locale: "de-DE",
          min: _vm.minDate,
          max: _vm.maxDate,
          readonly: _vm.readonly,
          "no-title": _vm.type === "year",
          "picker-date": _vm.pickerDate,
          scrollable: _vm.type === "year"
        },
        on: {
          "update:pickerDate": function($event) {
            _vm.pickerDate = $event
          },
          "update:picker-date": function($event) {
            _vm.pickerDate = $event
          },
          "click:year": function(v) {
            return _vm.onSelectYear(v)
          },
          change: _vm.onChangeDate
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }